

import { Injectable } from "@angular/core";
import { MapperInterface } from "@app/shared/mapper/mapper-inteface";
import { MapperUtente } from "./mapper-utente";
import { VisibilitaRequestDTO } from "../dto/visibilita-requestDTO";
import { VisibilitaRequestVO } from "../vo/visibilita-requestVO";
import { TipoVisibilitaEnum } from "../enum/tipo-visibilita-enum";




@Injectable({
    providedIn: 'root'
})
export class MapperVisibilitaRequest implements MapperInterface<VisibilitaRequestDTO, VisibilitaRequestVO> {
    constructor(
        private mapperUtente: MapperUtente
    ) {

    }
    convertVoToDto(vo: VisibilitaRequestVO): VisibilitaRequestDTO {
        if (vo != null) {
            const dto = new VisibilitaRequestDTO();
            // ATTENZIONE!! fare mapper questa riga funge solo se DTO e VO sono identici
            dto.idElemento = vo.idElemento;
            dto.tipoElemento = vo.tipoElemento;
            dto.tipoVisibilita = vo.tipoVisibilita;
            dto.utente = this.mapperUtente.convertVoToDto(vo.utente);
            return dto;
        } else {
            return null;
        }
    }

    convertDtoToVo(dto: VisibilitaRequestDTO): VisibilitaRequestVO {
        if (dto != null) {
            const vo = new VisibilitaRequestVO();

            vo.idElemento = dto.idElemento;
            vo.tipoElemento = dto.tipoElemento;
            if (vo.tipoVisibilita != TipoVisibilitaEnum.NESSUNA) {
                vo.tipoVisibilita = dto.tipoVisibilita;
            }
            vo.utente = this.mapperUtente.convertDtoToVo(dto.utente);
            return vo;
        } else {
            return null;
        }
    }

    convertListVoToDto(voList: VisibilitaRequestVO[]): VisibilitaRequestDTO[] {
        if (voList != null) {
            return voList.map(vo => this.convertVoToDto(vo));
        } else {
            return null;
        }
    }

    convertListDtoToVo(dtoList: VisibilitaRequestDTO[]): VisibilitaRequestVO[] {
        if (dtoList != null) {
            return dtoList.map(dto => this.convertDtoToVo(dto));
        } else {
            return null;
        }
    }
}
